/**
 * The purpose of this file is to handle all basic functionality such as
 * startup configurations and such.
 */
var Basics = Class.create({
    initialize: function(attachDOM) {
		var preLooaderOptions = {
			timeToHide:1200, //Time in milliseconds for fakeLoader disappear
			zIndex:"9999",//Default zIndex
			spinner:"spinner4",//Options: 'spinner1', 'spinner2', 'spinner3', 'spinner4', 'spinner5', 'spinner6', 'spinner7'
			bgColor:"#0078FF" //Hex, RGB or RGBA color 
        }
        this.navbar_initialized = false;
        this.navbar_menu_visible = 0;
		// #  Store our Preloader id
		this.preLoaderDOM = ".preLoader";
		this.preLoaderTag = '<div class="preLoader"></div>'
		// #  Store our preloader options for use when loading data
		this.preLoaderOptions = preLooaderOptions;
		// #  Store variable we use to attach our elements to
        this.attachDOM = attachDOM;
		this.bodyDOM = "body";
		// #  Lets create a array list of all of our dom elements we need to remove on reset
		this.removeDOM = [];
        // #  Trigger first time loader
        this.firstTimeLoader();
	},
    resetLoader: function() {
        jQuery(this.preLoaderDOM).remove();
        jQuery(this.bodyDOM).append(this.preLoaderTag);
        jQuery(this.preLoaderDOM).fakeLoader(this.preLoaderOptions);
    },
    showLoader: function() {
        jQuery(this.preLoaderDOM).show();
    },
    removeLoader: function() {
        jQuery(this.preLoaderDOM).hide();
    },
    firstTimeLoader: function(){
        jQuery(this.preLoaderDOM).fakeLoader(this.preLoaderOptions);
        // #  Because we have already loaded, lets reset the zindex
        this.preLoaderOptions.zIndex = "999";
    },
    initRightMenu: function(){}
});

export let basics = new Basics("#app");


// WEBPACK FOOTER //
// app/core/engine/helpers/basics.js